// Keep every visible slice selectable. Less-used words get 100 times the weight
// of previously selected words; the most recent word is always downweighted.
export const REPEAT_WEIGHT = 0.01;

export function createWeightedWheelSelection(random = () => Math.random()) {
  const counts = new Map();
  let last = null;

  return {
    select(items) {
      if (!items.length) return null;
      const minimum = Math.min(...items.map(item => counts.get(item.text) || 0));
      const weights = items.map(item => item.text === last || (counts.get(item.text) || 0) > minimum ? REPEAT_WEIGHT : 1);
      let cursor = random() * weights.reduce((sum, weight) => sum + weight, 0);
      for (let index = 0; index < items.length; index += 1) {
        cursor -= weights[index];
        if (cursor < 0 || index === items.length - 1) return { item: items[index], index };
      }
      return null;
    },
    complete(item) {
      counts.set(item.text, (counts.get(item.text) || 0) + 1);
      last = item.text;
    },
  };
}
